import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedSpreadsheet from "./components/FeaturedSpreadsheet";
import TrustSafety from "./components/TrustSafety";
import EditorialPolicy from "./components/EditorialPolicy";
import ArticleEntry from "./components/ArticleEntry";
import SafetyCenter from "./components/SafetyCenter";
import LatestGuides from "./components/LatestGuides";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedSpreadsheet />
        <TrustSafety />
        <EditorialPolicy />
        <SafetyCenter />
        <ArticleEntry />
        <LatestGuides />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}